import React, { useMemo } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import LocalAudioLevelIndicator from '../../../LocalAudioLevelIndicator/LocalAudioLevelIndicator';
import { LocalVideoTrack } from 'twilio-video';
import VideoTrack from '../../../VideoTrack/VideoTrack';
import useVideoContext from '../../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    height: 0,
    // overflow: 'hidden',
    // paddingTop: `${(9 / 16) * 100}%`,
    background: 'rgb(38, 42, 44)',
    [theme.breakpoints.down(750)]: {
      position: 'relative',
      height: 0,
      // overflow: 'hidden',
      // paddingTop: `${(9 / 16) * 100}%`,
      background: 'rgb(38, 42, 44)',
    },
  },
  container1: {
    position: 'relative',
    height: 0,
    // overflow: 'hidden',
    // paddingTop: `${(9 / 16) * 100}%`,
    background: 'rgb(38, 42, 44)',
    [theme.breakpoints.down(750)]: {
      position: 'unset',
      height: 0,
      // overflow: 'hidden',
      // paddingTop: `${(9 / 16) * 100}%`,
      background: 'rgb(38, 42, 44)',
    },
  },
  innerContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '296px',
    [theme.breakpoints.down(750)]: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '296px',
    },
  },
  innerContainer1: {
    position: 'absolute',
    top: 0,
    left: '0',
    width: '100%',
    height: '128px',
    minHeight: '90px',
    [theme.breakpoints.down(750)]: {
      height: '167px',
      minHeight: '90px',
      left: '2.5%',
      width: '95.5%',
      // maxHeight: '90px',
    },
  },
  // identityContainer: {
  //   position: 'absolute',
  //   bottom: 0,
  //   zIndex: 1,
  // },
  // identity: {
  //   background: 'rgba(0, 0, 0, 0.5)',
  //   color: 'white',
  //   padding: '0.18em 0.3em',
  //   margin: 0,
  //   display: 'flex',
  //   alignItems: 'center',
  // },
  avatarContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgb(38, 42, 44)',
    height: '296px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      '& svg': {
        transform: 'scale(0.7)',
      },
    },
  },
  avatarContainer1: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgb(38, 42, 44)',
    height: '128px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      '& svg': {
        transform: 'scale(0.7)',
      },
    },
    [theme.breakpoints.down(750)]: {
      height: '167px',
      minHeight: '90px',
      // maxHeight: '90px',
    },
  },
  audioBar: {
    position: 'absolute',
    left: '115px',
    top: '20px',
  },
}));

export default function LocalVideoPreview({ identity, checkIn }: { identity: string; checkIn?: boolean }) {
  const classes = useStyles();
  const { localTracks } = useVideoContext();
  const videoTrack = useMemo(() => localTracks.find(track => track.name.includes('camera')) as LocalVideoTrack, [
    localTracks,
  ]);

  return identity === '' && !checkIn ? (
    <div className={classes.container1}>
      <div className={classes.innerContainer1}>
        {videoTrack ? (
          <VideoTrack track={videoTrack} isLocal />
        ) : (
          <div className={classes.avatarContainer1}>
            <span style={{ color: 'white' }}>No camera selected!</span>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
        {videoTrack ? (
          <VideoTrack track={videoTrack} isLocal />
        ) : (
          <div className={classes.avatarContainer}>
            {/* <AvatarIcon /> */}
            {/* <LocalAudioLevelIndicator/> */}
            <span style={{ color: 'white' }}>No camera selected!</span>
          </div>
        )}
      </div>
      <div className={classes.audioBar}>
        <LocalAudioLevelIndicator show />{' '}
      </div>
    </div>
  );
}
